import { getThreadDialogLazyImport as getNewThreadDialogLazyImport } from '@canvas/comments/new-comment-components/thread/dialog';
import { getThreadDialogLazyImport } from '@canvas/comments/thread/dialog';
import { preloader, PreloaderPriority } from '@canvas/preloader';

// Preload comments lazy-loaded components
export const initializeCommentsPreloaders = () => {
  preloader.scheduleAll({
    ThreadDialog: {
      task: () => getThreadDialogLazyImport(),
      priority: PreloaderPriority.LOW,
    },
    NewThreadDialog: {
      task: () => getNewThreadDialogLazyImport(),
      priority: PreloaderPriority.LOW,
    },
  });
};
